import React from 'react';
import { Fab, Tooltip, Badge, useMediaQuery, useTheme } from '@mui/material';
import BugReportIcon from '@mui/icons-material/BugReport';

interface DebugSaveFabProps {
  onClick: () => void;
  hasDebugInfo: boolean;
}

/**
 * Floating action button for viewing save debug information
 * Positioned to the left of the confetti debug FAB
 */
const DebugSaveFab: React.FC<DebugSaveFabProps> = ({
  onClick,
  hasDebugInfo,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Tooltip title="View Save Debug Information" placement="left">
      <Badge
        color="error"
        variant="dot"
        invisible={!hasDebugInfo}
        overlap="circular"
        sx={{
          position: 'fixed',
          bottom: isMobile ? 80 : 30,
          right: 140, // Positioned to the left of confetti FAB (which is at right: 80)
          zIndex: 900,
        }}
      >
        <Fab
          color="default"
          size="medium"
          sx={{
            bgcolor: 'grey.700',
            color: 'white',
            '&:hover': {
              bgcolor: 'grey.800',
            },
          }}
          onClick={onClick}
          data-testid="debug-save-fab"
        >
          <BugReportIcon />
        </Fab>
      </Badge>
    </Tooltip>
  );
};

export default React.memo(DebugSaveFab);
